// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1BhPEIx-kEjYk1GU_IVn5c","icon":"_3-PbcLpbPWWZGPa_fUM3DQ","active":"_2jg43MUg6OWuw_Xo6DcCDr"};